// TODO 所有公众号家长端相关页面路由在此配置
// TODO 所有路由的path必须以 /account/ 开头
// TODO 所有路由的name以及webpackChunkName必须以 account 开头

export default [
  {
    path: '/',
    redirect: { name: 'accountInfo' }
  },
  {
    path: '/account/timetable',
    name: 'accountTimetable',
    component: () => import(/* webpackChunkName: "accountTimetable" */ '@/views/account/timetable.vue'),
    meta: {
      title: '我的课表'
    }
  },
  {
    path: '/account/course-info',
    name: 'accountCourseInfo',
    component: () => import(/* webpackChunkName: "accountCourseInfo" */ '@/views/account/course-info.vue'),
    meta: {
      title: '课程详情'
    }
  },
  {
    path: '/account/info',
    name: 'accountInfo',
    component: () => import(/* webpackChunkName: "accountInfo" */ '@/views/account/info.vue'),
    meta: {
      title: 'VIPKID数学思维'
    }
  },
  {
    path: '/account/choose-course',
    name: 'accountChooseCourse',
    component: () => import(/* webpackChunkName: "accountChooseCourse" */ '@/views/account/choose-course.vue'),
    meta: {
      title: '选择课程'
    }
  },
  {
    path: '/account/master-detail/:courseStageId',
    name: 'accountMasterDetail',
    component: () => import(/* webpackChunkName: "accountMasterDetail" */ '@/views/account/master-detail.vue'),
    meta: {
      title: '班主任详情'
    }
  },
  {
    path: '/account/appointment',
    name: 'accountAppointment',
    component: () => import(/* webpackChunkName: "accountAppointment" */ '@/views/account/appointment.vue'),
    meta: {
      title: '已报课程'
    }
  },
  {
    path: '/account/help',
    name: 'accountHelp',
    component: () => import(/* webpackChunkName: "accountAppointment" */ '@/views/account/help.vue'),
    meta: {
      title: '帮助中心'
    }
  },
  {
    path: '/account/device',
    name: 'accountDevice',
    component: () => import(/* webpackChunkName: "accountDevice" */ '@/views/account/device.vue'),
    meta: {
      title: '设备要求'
    }
  },
  {
    path: '/account/setting',
    name: 'accountSetting',
    component: () => import(/* webpackChunkName: "accountSetting" */ '@/views/account/setting.vue'),
    meta: {
      title: '设置'
    }
  }
]
